import * as React from 'react';

import PageSection from 'components/page/page-section/PageSection';

type Props = {
  title: string,
  message: string
};

class SharedAccessError extends React.PureComponent<Props> {
  render() {
    const { title, message } = this.props;

    return (
      <PageSection>
        <section className="shared-access-error">
          <div className="shared-access-error__title">{title}</div>
          <div className="shared-access-error__message">{message}</div>
        </section>
      </PageSection>
    );
  }
}

export default SharedAccessError;
